export default __webpack_public_path__ + "static/media/icon-bybit-button.78e29fde.png";